<template>
  <scroll-right-frame>
  <uploader :options="options"  @file-added="onFileAdded" @file-success="fileSuccess" class="uploader-example">
      <uploader-unsupport></uploader-unsupport>
      <uploader-drop>
      <p>
        <img :src="picUrl" >
      </p>
      </uploader-drop>
      <uploader-list></uploader-list>
       <br />
       <uploader-btn :attrs="attrs">选择文件</uploader-btn>
 </uploader>
 <br />
<el-form>
 <el-form-item size="large" style="text-align: center;">
                <el-button size="small" type="primary"  @click="update()" class="btn btn-solid"  >保存</el-button> 
                <el-button  size="small"  type="primary"  @click="goback()" class="btn btn-solid"  >返回</el-button> 
  </el-form-item>
</el-form>         
</scroll-right-frame>
</template>

<script>
  import Vue from 'vue'
  import ScrollRightFrame from '../../../components/scroll-right-frame'
  import uploader from 'vue-simple-uploader'
  import SparkMD5 from 'spark-md5'
  import util from '../../../libs/util'
  Vue.use(uploader);
  export default {
    name: 'department-view-update-photo',
    components: {ScrollRightFrame},
    data () {
        return {
        options: {
           headers: {
                    Authorization:"bearer "+util.token()
                  },
          target: '//'+util.apiBasePath+'/jpcp/uploader/chunk',
          testChunks: true,
          simultaneousUploads: 10,
          chunkSize: 1024 * 512,
          single:true,
          checkChunkUploadedByResponse: function (chunk, message) {
              let objMessage = JSON.parse(message);
              console.info(objMessage);
              if (objMessage.skipUpload) {
                     return true;
              }
           },
           },
        attrs: {
          accept: 'image/jpeg,image/jpg,image/png'
        },
        fileStatusText : {
          success: '成功了',
          error: '出错了',
          uploading: '上传中',
          paused: '暂停中',
          waiting: '等待中'
        },
        picUrl:"",
        fileId:'',
        actionId:'department_jpcp',
        gridId:'department_jpcp'  
      }
    },
    mounted(){
        this.getDetail()
    },
    methods: {
      goback(){
            util.routerBack(this,"/");
      },
      fileSuccess (rootFile, file, message, chunk) {
           util.ajax.post("/jpcp/uploader/createFile",{
              fileName:file.name,
              meteId:file.uniqueIdentifier    
          }).then((res) => {
                this.$notify.success({title: '提示', message: '上传成功'});
                this.fileId =res.data.file.id;
                file.cancel();
              }).catch((e) => {
                
              });
      },
      getDetail:function(){
              util.ajax.post("/jpcp/department/abstractDetail?actionId="+this.gridId,
                      {
                        "params":{"actionId":this.gridId},
                        "page":{"searchItem":{"id":"="+this.$route.query.id}}
                      }).then((res) => {
                          if (res.data.meta.errCode == 0) {
                                var data = res.data.data;
                                 var item  =data["items"][0];
                               var  url = this.getFileById(item.cachetPhoto);
                               this.picUrl =url;
                          }
                      }).catch((e) => {
                                      
                      });
                    },
      getFileById(fileId){
         var  fileUrl ='//'+util.apiBasePath+'/jpcp/uploader/file/'+fileId;
         return fileUrl;
      } ,     
       update:function(){
         if(this.fileId.length ==0){
             this.$notify.error({title: '提示', message: '请先上传图片'});
             return;
         }
          util.ajax.post("/jpcp/department/abstractUpdate?actionId="+this.actionId,
          {
            "bean":{"id":this.$route.query.id},
            "params":{"gridId":this.gridId,"actionId":this.actionId,"update_single_attr":"update_single_attr",'beanData':{"cachetPhoto":this.fileId}}
            }).then((res) => {
                        this.$notify.success({title: '提示', message: '保存成功'});
                        this.goback();
                }).catch((e) => {
                        
              });
       },
       statusSet:function(fileId,value ){

       },
       onFileAdded:function(file){
          var reader = new FileReader();
          reader.readAsDataURL(file.file);
          const _that = this;
          reader.onload = function(e){
             let image = new Image();
              image.src = e.target.result;
              image.onload = function() {
                let width = `${this.width}`;
                let height = `${this.height}`;
                if( width > 800 || height > 800){
                    _that.$notify.error({title: '提示', message: '图片宽度不能大于800,图片高度不能大于800'});
                     file.pause();
                    file.cancel();
                }else{
                 _that.picUrl =e.target.result;
                }
              }
          } 
         this.computeMD5(file);
       },computeMD5(file) {
                let fileReader = new FileReader();
                let time = new Date().getTime();
                let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
                let currentChunk = 0;
                const chunkSize = 10 * 1024 * 1000;
                let chunks = Math.ceil(file.size / chunkSize);
                let spark = new SparkMD5.ArrayBuffer();
                // 文件状态设为"计算MD5"
                this.statusSet(file.id, 'md5');
                //file["name"] ="122";
                file.pause();
                console.info(file["status"]);
                loadNext();
                fileReader.onload = (e => {
                    spark.append(e.target.result);
                        let md5 = spark.end();
                        file.uniqueIdentifier = md5;
                        file.resume();
                });
                fileReader.onerror = function () {
                    this.error(`文件${file.name}读取出错，请检查该文件`)
                    file.cancel();
                };
                function loadNext() {
                    let start = currentChunk * chunkSize;
                    let end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;
                    fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
                }
            }
    }
  }
</script>
<style lang="scss">
  .uploader-example {
    width: 880px;
    padding: 15px;
    margin: 40px auto 0;
    font-size: 12px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .4);
  }
  .uploader-example .uploader-btn {
    margin-right: 4px;
  }
  .uploader-example .uploader-list {
    max-height: 440px;
    overflow: auto;
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/custom/components/jpcp/department-view-update-photo.vue